import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from './client.js';
import type {
  BillingRunReport, BillingRunRequest, BillingRuns, MonthlyCharges,
} from '@arcnet/contracts';

export const subscriptionKeys = {
  charges: (tenantId: string) => ['monthly-charges', tenantId] as const,
  runs: () => ['billing-runs'] as const,
};

/** What an account is billed each month, and the current period so far. */
export const useMonthlyCharges = (tenantId: string | null) =>
  useQuery({
    queryKey: subscriptionKeys.charges(tenantId ?? ''),
    queryFn: () => api.get<MonthlyCharges>(`/v1/tenants/${tenantId}/billing/subscriptions`),
    enabled: !!tenantId,
  });

export const useBillingRuns = () =>
  useQuery({
    queryKey: subscriptionKeys.runs(),
    queryFn: () => api.get<BillingRuns>('/v1/billing/runs'),
  });

export function useRunBilling() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: BillingRunRequest) =>
      api.post<BillingRunReport>('/v1/billing/runs/actions/run', body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: subscriptionKeys.runs() });
      void qc.invalidateQueries({ queryKey: ['invoices'] });
    },
  });
}
